import getLocalizedRoute from '~/utils/getLocalizedRoute'
import { Routes } from '~/enums/Routes'
import { fetchRetryParameters, requestHostHeaders, type RequestHostHeadersType } from '~/composables/constants/api'

interface standardResponse {
  status: boolean
  message: string | null
  redirect: string | null
}

interface requiresActionResponse {
  requires_action: boolean
  payment_intent_client_secret: string
  order_id: string
}

export default async (orderId: string, stripeToken: string): Promise<standardResponse | requiresActionResponse> => {
  const response = await $fetch('/api/payments/execute-stripe-payment', {
    method: 'POST',
    body: {
      orderId,
      stripeToken,
    },
    ...fetchRetryParameters,
    headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
  })

  const router = useRouter()
  const cancelRoute = getLocalizedRoute(Routes.Payment.Decline, {}, { orderId })

  const result: { status: boolean; message: null | string; redirect: any } = {
    status: false,
    message: null,
    redirect: new URL(router.resolve(cancelRoute).href, window.location.origin).href,
  }

  if ((response.status ?? false) === true) {
    result.redirect = null

    if (response.requires_action && response.payment_intent_client_secret) {
      return {
        requires_action: true,
        payment_intent_client_secret: response.payment_intent_client_secret,
        order_id: orderId,
      }
    }
    if (response.orderId) {
      result.status = true
      const acceptRoute = getLocalizedRoute(Routes.Payment.Accept, {}, { orderId })
      result.redirect = new URL(router.resolve(acceptRoute).href, window.location.origin).href
    } else if (response.message) {
      result.message = response.message
    } else {
      result.message = 'balance.something_went_wrong'
    }
  }

  return result
}
